import { render, staticRenderFns } from "./LoginClassic.vue?vue&type=template&id=7e852c8a&scoped=true"
import script from "./LoginClassic.vue?vue&type=script&lang=js"
export * from "./LoginClassic.vue?vue&type=script&lang=js"
import style0 from "./LoginClassic.vue?vue&type=style&index=0&id=7e852c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e852c8a",
  null
  
)

export default component.exports